import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'desktop-entry-summary-card',
  template: `
    <div class="entry-summary-data-card" [ngClass]="{ 'is-valid': isValid }">
      <div class="entry-summary-data-card-header">
        <div class="entry-summary-data-card-header-info">
          <div class="d-flex align-items-center">
            <span *ngIf="isValid">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0757 16.7728L6.17573 12.8728C5.94142 12.6385 5.94142 12.2586 6.17573 12.0243L7.02424 11.1757C7.25854 10.9414 7.63846 10.9414 7.87277 11.1757L10.5 13.8029L16.1272 8.17573C16.3615 7.94142 16.7415 7.94142 16.9758 8.17573L17.8243 9.02426C18.0586 9.25857 18.0586 9.63846 17.8243 9.87279L10.9243 16.7728C10.6899 17.0071 10.31 17.0071 10.0757 16.7728Z"
                  fill="currentColor"
                />
              </svg>
            </span>

            <h3>{{ cardTitle | translate }}</h3>
          </div>

          <ng-content select="[header]"></ng-content>
        </div>
      </div>

      <div class="entry-summary-data-card-body">
        <div class="entry-summary-data-card-body-data">
          <ng-content select="[body]"></ng-content>
        </div>
      </div>

      <div class="entry-summary-data-card-footer"></div>
    </div>
  `,
  styleUrls: ['./es-card-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsCardDesktopComponent {
  @Input() public cardTitle: string;
  @Input() public isValid: boolean;
}
